// export function getDisplayName(client, participants = []) {
//   const firstname = client?.firstname?.trim();
//   const lastname = client?.lastname?.trim();

import { messageCategory, messageSubCategory } from "../constants/message.catergory";
import { messageTemplate } from "../constants/template.category";
import { isEmpty } from "../helpers/functions.helper";

//   if (firstname && lastname) return `${firstname} ${lastname}`;
//   if (firstname) return firstname;
//   if (lastname) return lastname;

//   return participants?.[0] || "Unnamed";
// }

export function getDisplayName( client, participants = [], contact = null) {
  const clean = (v) => v?.trim?.();
  
  const contactFirst = clean(contact?.firstName);
  const contactLast = clean(contact?.lastName);

  if (contactFirst && contactLast) return `${contactFirst} ${contactLast}`;
  if (contactFirst) return contactFirst;
  if (contactLast) return contactLast;

  const clientFirst = clean(client?.firstname);
  const clientLast = clean(client?.lastname);

  if (clientFirst && clientLast) return `${clientFirst} ${clientLast} (Client)`;
  if (clientFirst) return clientFirst;
  if (clientLast) return clientLast;

  const fallback = clean(participants?.[0]);
  return fallback ?? "Loading...";
}

export function getFirstName( client, contact = null) {
  const clean = (v) => v?.trim?.();

  const clientFirst = clean(client?.firstname);
  if (clientFirst) return clientFirst;

  const contactFirst = clean(contact?.firstName?.split(" ")?.at(0));
  if (contactFirst) return `${contactFirst}`;

  return "";
}

// export function getMessage({
//   category_name, 
//   client_name = "", 
//   market = "",
//   propertyName= "",
//   sub_category_name = ""
// }) {
//   let message = ""
//   switch(category_name){
//     case messageCategory.moveInCheckIn:
//       message = (messageTemplate?.[messageCategory.moveInCheckIn] ?? "").replace("{{ClientName}}",client_name).replace("{{PropertyName}}",propertyName)
//       if(isEmpty(propertyName)) message = message.replace(" at ", "")
//       return message
//     case messageCategory.paidCheckIn:
//       message = (messageTemplate?.[messageCategory.paidCheckIn] ?? "").replace("{{ClientName}}",client_name).replace("{{PropertyName}}",propertyName)
//       if(isEmpty(propertyName)) message = message.replace(" at ", "")
//       return message
//     case messageCategory.renewalCheckIn:
//       return (messageTemplate?.[messageCategory.renewalCheckIn] ?? "").replace("{{ClientName}}",client_name)
//     case messageCategory.tourCheck:
//       return (messageTemplate?.[messageCategory.tourCheck] ?? "").replace("{{ClientName}}",client_name)
//     case messageCategory.lastFollowUp:
//       return (messageTemplate?.[messageCategory.lastFollowUp] ?? "").replace("{{ClientName}}",client_name)
//     case messageCategory.followUp:
//       //window.alert(market, "  ")
//       if(sub_category_name == messageSubCategory[messageCategory.followUp].firstFollowUp){
//         return (messageTemplate?.[messageCategory.followUp]?.[messageSubCategory[messageCategory.followUp].firstFollowUp] ?? "").replace("{{ClientName}}",client_name)
//       }
//       else if(sub_category_name == messageSubCategory[messageCategory.followUp].secondFollowUp){
//         return (messageTemplate?.[messageCategory.followUp]?.[messageSubCategory[messageCategory.followUp].secondFollowUp] ?? "").replace("{{ClientName}}",client_name)
//       }
//       else if(sub_category_name == messageSubCategory[messageCategory.followUp].thirdFollowUp){
//         return (messageTemplate?.[messageCategory.followUp]?.[messageSubCategory[messageCategory.followUp].thirdFollowUp] ?? "").replace("{{ClientName}}",client_name)
//       }
//       else if(sub_category_name == messageSubCategory[messageCategory.followUp].fourthFollowUp){
//         return (messageTemplate?.[messageCategory.followUp]?.[messageSubCategory[messageCategory.followUp].fourthFollowUp] ?? "").replace("{{ClientName}}",client_name)
//       }
//       else{
//         return ""
//       }
//     default:
//       return message
//   }
// }

//Utility to safely replace placeholders in a template string.
function fillTemplate(template, replacements = {}) {
  let filled = template;
  for (const [key, value] of Object.entries(replacements)) {
    filled = filled.replaceAll(`{{${key}}}`, value ?? "");
  }
  return filled.trim();
}

//Click to text message generator
export function getMessage({
  category_name,
  sub_category_name = "",
  client_name = "",
  propertyName = "",
  market = "",
}) {
  if (!category_name) return "";

  let template = "";

  // handle categories with subcategories
  if (category_name === messageCategory.followUp) {
    const subCategoryMap = messageSubCategory?.[messageCategory.followUp];
    const validSub = Object.values(subCategoryMap || {}).includes(sub_category_name);

    if (validSub) {
      template =
        messageTemplate?.[messageCategory.followUp]?.[sub_category_name] ?? "";
    }
  } else {
    // handle top-level templates
    template = messageTemplate?.[category_name] ?? "";
  }

  if (!template) return "";

  // Replace placeholders
  const message = fillTemplate(template, {
    ClientName: client_name,
    PropertyName: propertyName,
    Market: market,
  });

  // Clean up artifacts like " at " when propertyName is empty
  return isEmpty(propertyName)
    ? message.replace(/\s+at\s+/gi, " ").trim()
    : message;
}
